import useScrollReveal from './shared/useScrollReveal';

export default function Highlights() {
  const ref = useScrollReveal();

  return (
    <section className="vf" id="highlights" ref={ref}>
      <div className="containers-min mx-auto px-4 py-12">
        <div className="vf-top">
          <div>
            <div className="vf-eyebrow">Feature Highlights</div>
            <h2 className="vf-h2 section-title">
              Every Feature. <br />
              <span>Built for a Reason.</span>
            </h2>
          </div>
        </div>

        <div className="vf-bento">
          {/* Dual-Standard Charging */}
          <div className="vf-cell c1 tall">
            <div>
              <div className="vf-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M12 2 4 6v6c0 5 3.5 8 8 10 4.5-2 8-5 8-10V6l-8-4z" />
                  <path d="M9 12l2 2 4-4" />
                </svg>
              </div>
              <div className="vf-title">Dual-Standard Charging</div>
              <p className="vf-desc">
                Supports compatible LEV charging standards, helping serve a
                wider range of electric two- and three-wheelers.
              </p>
            </div>
          </div>

          {/* Independent Power Delivery */}
         <div className="vf-cell c2">
            <div className="vf-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                {/* two prongs */}
                <path d="M9 2v5" />
                <path d="M15 2v5" />
                {/* adapter/plug body */}
                <rect x="6" y="7" width="12" height="8" rx="2" />
                {/* power bolt inside the adapter body */}
                <path d="M13 9l-2.5 3.2H12L10.5 15" />
                {/* cord trailing out the bottom */}
                <path d="M12 15v2c0 2 2 3 2 5" />
              </svg>
            </div>
            <div className="vf-title">Independent Power Delivery</div>
            <p className="vf-desc" style={{ maxWidth: 400 }}>
              Delivers dedicated power to each connected vehicle for reliable
              and efficient charging.
            </p>
          </div>

          {/* Compact Footprint */}
          <div className="vf-cell c3">
            <div className="vf-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" />
              </svg>
            </div>
            <div className="vf-title">Compact Footprint</div>
            <p className="vf-desc">
              Delivers powerful DC charging in a space-efficient design that
              fits easily into diverse locations.
            </p>
          </div>

          {/* Smart Connectivity */}
          <div className="vf-cell c4">
            <div className="vf-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12.55a11 11 0 0 1 14.08 0" />
                <path d="M1.42 9a16 16 0 0 1 21.16 0" />
                <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
                <circle cx="12" cy="20" r="1" fill="#007a40" />
              </svg>
            </div>
            <div className="vf-title">Smart Connectivity</div>
            <p className="vf-desc">
              Stay connected with remote monitoring, management and control
              capabilities.
            </p>
          </div>

          {/* OCPP Compatibility */}
          <div className="vf-cell c5">
            <div className="vf-icon">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
              </svg>
            </div>
            <div className="vf-title">OCPP Compatibility</div>
            <p className="vf-desc">
              Enables seamless integration with compatible charging management
              systems and networks.
            </p>
          </div>

          {/* Fast DC Charging */}
          <div className="vf-cell c6 wide">
            <div className="vf-cell-body">
              <div className="vf-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path
                    d="M13 2 6 13h5l-1 9 7-11h-5l1-9z"
                    fill="currentColor"
                    fillOpacity="0.15"
                  />
                </svg>
              </div>
              <div className="vf-title">Fast DC Charging</div>
              <p className="vf-desc" style={{ maxWidth: 560 }}>
                Helps compatible vehicles get back on the road faster with
                efficient DC power delivery. Designed for quick, reliable, and convenient charging when time matters.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
